import React, { ReactNode } from 'react';
import classNames from 'classnames';
import cls from './ProgressbarLineList.module.css';
import { useProgressbarLineList } from './useProgressbarLineList';

interface ProgressbarLineListProps {
    classes?: string;
    children: ReactNode;
}

export const ProgressbarLineList = ({ classes, children }: ProgressbarLineListProps) => {
    const {} = useProgressbarLineList();
    return <div className={classNames(cls.ProgressbarLineList, [classes])}>{children}</div>;
};
